import { Middleware } from '@reduxjs/toolkit';

export const loggerMiddleware: Middleware = store => next => action => {
    if (process.env.NODE_ENV !== 'production') {
        const actionType = (action as { type?: string }).type || 'UNKNOWN_ACTION';
        console.group(actionType);
        console.info('dispatching', action);
        const result = next(action);
        console.log('next state', store.getState());
        console.groupEnd();
        return result;
    }
    return next(action);
};
